import { useEffect, useState } from "react";
import { BlogsFromAPI } from "../../interfaces/blog/BlogsFromAPI";
import { getBlogs } from "../../api/listings";
import { useBlogContext } from "../../components/blog/blogsPage";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export const useGetBlogs = () => {
  const [blogs, setBlogs] = useState<BlogsFromAPI>(null);
  const { dispatch } = useBlogContext();
  const blogFilters = useSelector((state: RootState) => state.filters.blogs);

  useEffect(() => {
    const getDigitalAssets = async () => {
      dispatch({ isLoading: true });
      const blogs = await getBlogs(blogFilters.queryStringFilter, 0);
      setBlogs(blogs);
      dispatch({ blogs: blogs, isLoading: false, page: 0, hasMoreBlogs: true });
    };

    void getDigitalAssets();
  }, [blogFilters.queryStringFilter, dispatch]);

  return { blogs, setBlogs };
};
